<section class="header-container">
  <div class="route-container">
    <span (click)="navigateBacK()">{{ 'text_products' | dbText }}</span>
    <i class="db-icon db-icon-ds-arrow-right"></i>
    <span>{{(isEdit ? "text_editProductTitle" : "text_addProductTitle") | dbText }}</span>
  </div>
  <div class="actions-container">
    <button class="ds-btn"
            (click)="discardEmitter.emit()"
            [ngClass]="{'ds-btn-disabled': false}">
      {{'text_productsDiscardBtn' | dbText}}
    </button>

    <button class="ds-btn-black"
            *ngIf="isEdit ;else createBtn"
            (click)="updateEmitter.emit()"
            [ngClass]="{'ds-btn-disabled': false}">
      {{'text_update'| dbText}}
    </button>

    <ng-template #createBtn>
      <button class="ds-btn-black"
              [dsTooltip]="dropdownList"
              [dsTooltipColor]="'black'"
              dsTooltipMode="click"
              dsTooltipPosition="bottom"
              dsTooltipAlign="right"
              dsTooltipSize="xs"
              [ngClass]="{'ds-btn-disabled': false}">
        {{'text_create' | dbText}}
      </button>
      <ng-template #dropdownList>
        <div class="product-dropdown-list">
          <div class="db-dropdown-list__content">
            <a class="db-dropdown-list__item" (click)="saveEmitter.emit(false)">
              <span>{{ 'text_publish' | dbText }}</span>
            </a>
            <a class="db-dropdown-list__item" (click)="saveEmitter.emit(true)">
              <span>{{ 'text_saveAsADraft' | dbText }}</span>
            </a>
          </div>
        </div>
      </ng-template>
    </ng-template>
    <a *ngIf="isEdit && isPublished"
       class="view-container"
       target="_blank"
       [href]="productUrl">
      <i class="db-icon db-icon-eye"></i>
    </a>
  </div>
</section>

